import React, { useState, useEffect, useRef } from "react";
import "./About.css";
import image from "../../images/abtImg.png";
import AboutDesc from "./AboutDesc/AboutDesc";
import Skills from "./Skills/Skills";
import Experience from "./Experience/Experience";
import Qualification from "./Qualification/Qualification";

const About = () => {
  const [activeLink, setActiveLink] = useState("Skills");
  const [isVisible, setIsVisible] = useState(false);
  const abtSecIRef = useRef(null);
  const abtImgRef = useRef(null);

  const handleLinkClick = (link) => {
    setIsVisible(false);
    setTimeout(() => {
      setActiveLink(link);
      setIsVisible(true);
    }, 300); // Adjust the delay as needed
  };

  const renderContent = () => {
    switch (activeLink) {
      case "Skills":
        return <Skills />;
      case "Qualification":
        return <Qualification />;
      case "Experience":
        return <Experience />;
      case "About Me":
      default:
        return <AboutDesc />;
    }
  };

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        const target = entry.target;
        if (entry.isIntersecting) {
          setIsVisible(true);
          target.classList.add("fadeInUp");
        } else {
          setIsVisible(false);
          target.classList.remove("fadeInUp");
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, options);

    // Observe the about section and img separately
    if (abtSecIRef.current) {
      observer.observe(abtSecIRef.current);
    }

    if (abtImgRef.current) {
      observer.observe(abtImgRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <section
      id="about"
      className={`about-container ${isVisible ? "visible" : "initialHide"}`}
    >
      <div className="aboutLinks">
        {["Skills", "Qualification", "Experience", "About Me"].map((link) => (
          <span
            key={link}
            className={activeLink === link ? "active" : ""}
            onClick={() => handleLinkClick(link)}
          >
            {link}
          </span>
        ))}
      </div>
      <div className="abtSec-I" ref={abtSecIRef}>
        <div className="abt-img" ref={abtImgRef}>
          <img src={image} alt="devices" />
        </div>
        {renderContent()}
      </div>
      <h1 className="abt-branding">
        Looking for a developer who is passionate about their work? Then you've
        come to the right place. Contact me today to discuss your project and
        let's see what we can create together!
      </h1>
    </section>
  )
};

export default About;
